export default {
  // random generated ID only used to signal that a user has been created.
  id: null,
  email: '',
  gladlyCustomerId: null,
  // user have given us email address => true, anonymous user => false
  hasOnboarded: false,
  name: '',
  // id to identify the user within the chat provider, generated on the server and coupled with the token
  userId: null,
  // a JWT used to authenticate with chat provider.
  token: null,
};
